import { Route, Redirect } from "react-router-dom"
import useAuth from "../Hooks/useAuth"
import { InfinitySpin } from "react-loader-spinner";


const PrivateRoute = ({ children, ...rest }) => {

    const { user, isLoading } = useAuth()

    if (isLoading) {
        return <div className="router-loading-spinner">
            <InfinitySpin color="#002060" />
        </div>
    }

    return (
        <Route
            {...rest}
            render={({ location }) =>
                user ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    )
}

export default PrivateRoute;